<div>
  <div class="header-style">
    <div class="h-100">
      @if (user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) {
        <mat-form-field appearance="outline" class="select">
          <mat-select data-testid="usedOnMobile_filter" (selectionChange)="filterChange($event.value)" [(value)]="selected" #usedOnMobile_filter  id="usedOnMobile_filter"
            name="usedOnMobile_filter">
            <mat-option i18n="@@EventsUsedonmobile" value="usedOnMobile">Events Used on mobile</mat-option>
            <mat-option i18n="@@EventsToPickFrom" value="manufacturer">Events To Pick From</mat-option>
          </mat-select>
        </mat-form-field>
      }
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <mat-paginator i18n-aria-label="@@paginator" [length]="totalSize" [pageSize]="pageSize" [pageIndex]="pageNumber - 1" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handlePage($event)"></mat-paginator>
      <mat-icon data-testid="add_event_button" (click)="addEvent()" class="cursor add-icon"  svgIcon="add" i18n-aria-label="@@addEvent" aria-label="Add Event"></mat-icon>
      
      @if (eventsList.length > 0) {
        <mat-menu #exportMenu="matMenu">
          <button mat-menu-item i18n="@@exportCSV" (click)="exportEvents(1)">Export as CSV</button>
          <button mat-menu-item i18n="@@exportPDF" (click)="exportEvents(2)">Export as PDF</button>
          <button mat-menu-item i18n="@@exportExcel" (click)="exportEvents(3)">Export as Excel</button>
        </mat-menu>
        <mat-icon svgIcon="export" class="cursor export-icon" i18n-aria-label="@@exportEvents" aria-label="Export Events" [matMenuTriggerFor]="exportMenu"></mat-icon>
      }

      <form [formGroup]="searchForm" (ngSubmit)="doSearch()">
        @if (showSearch) {
          <mat-form-field class="search-field">
            <mat-label i18n="@@searchLabel">Search</mat-label>
            <input data-testid="event_search_input" i18n-placeholder="@@searchPlaceholder" matInput formControlName="search" id="search" placeholder="Search" name="search"/>
            <mat-icon data-testid="event_clear_button" class="cursor" matSuffix i18n-aria-label="@@clearSearch" aria-label="Clear Search" (click)="clearSearch()">clear</mat-icon>
          </mat-form-field>
        }
      </form>
      <mat-icon data-testid="event_search_button" (click)="handleSearchClick()" class="cursor" svgIcon="search" i18n-aria-label="@@searchEvent" aria-label="Search Event"></mat-icon>
    </div>
  </div>
  @for (item of eventsList; track item; let itemIndex = $index) {
    <mat-card class="{{(itemIndex % 2 === 0 ? 'lite-box-without-img mr-16' : 'lite-box-without-img')}}">

      <mat-card-content class="content-box">
        <div (click)="openEventDetails(item)" class="flex-grow cursor w-90">
          <div class="mat-subtitle-1 mb-10" matTooltip ellipsisTooltip>{{item.name}}</div>
          <div class="mat-caption mb-8" matTooltip ellipsisTooltip>{{item.description}}</div>
          <div class="mat-caption mb-8" matTooltip ellipsisTooltip>{{item.country}}</div>
          <div class="mat-caption" matTooltip ellipsisTooltip>{{item.startDate}} - {{item.endDate}}</div>
        </div>

        @if (user.type === utils.userTypes.Manufacturer || user.type === utils.userTypes.ManufacturerChild) {
          <mat-icon class="cursor" [matMenuTriggerFor]="menu" color="accent" i18n-aria-label="@@moreOptions" aria-label="More options">more_vert</mat-icon>
        }
        @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'manufacturer') {
          <mat-icon class="{{item.usedOnMobile ? 'cursor header-icon' : 'header-icon-color cursor'}}" (click)="item.usedOnMobile ? moveToNotUsedOnMobile(item.id) : moveToUsedOnMobile(item.id)" i18n-aria-label="@@toggleUsedOnMobile" aria-label="Toggle Used on Mobile">stay_current_portrait</mat-icon>
        }
        @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'usedOnMobile' && item.isAddedByManufacturer === true) {
          <mat-icon class="cursor header-icon" (click)="moveToNotUsedOnMobile(item.id)" i18n-aria-label="@@moveToNotUsedOnMobile" aria-label="Move to Not Used on Mobile">stay_current_portrait</mat-icon>
        }
        @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'usedOnMobile' && item.isAddedByManufacturer === false) {
          <mat-icon class="cursor" [matMenuTriggerFor]="menu" color="accent" i18n-aria-label="@@moreOptions" aria-label="More options">more_vert</mat-icon>
        }

        <mat-menu #menu="matMenu">
          @if (item.isAddedByManufacturer === false) {
            <button i18n="@@edit" data-testid="edit_event_button" (click)="editEvent(item)" mat-menu-item>Edit</button>
          }
          @if (item.isAddedByManufacturer === false) {
            <button i18n="@@delete" data-testid="delete_event_button" (click)="deleteEvent(item.id)" mat-menu-item>Delete</button>
          }
          @if (item.isAddedByManufacturer === true && (user.type === utils.userTypes.Manufacturer || user.type === utils.userTypes.ManufacturerChild)) {
            <button i18n="@@edit" data-testid="edit_event_button" (click)="editEvent(item)" mat-menu-item>Edit</button>
          }
          @if (item.isAddedByManufacturer === true && (user.type === utils.userTypes.Manufacturer || user.type === utils.userTypes.ManufacturerChild)) {
            <button i18n="@@delete" data-testid="delete_event_button" (click)="deleteEvent(item.id)" mat-menu-item>Delete</button>
          }
          @if (item.isAddedByManufacturer === true && (user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild)) {
            <button i18n="@@unuseOnMobile" data-testid="unuse_event_button" (click)="moveToUnUsedOnMobile(item.id)" mat-menu-item>Unuse on mobile</button>
          }
        </mat-menu>

      </mat-card-content>
    </mat-card>
  }
  @if (eventsList.length === 0) {
    <img class="empty-view-img" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}" i18n-alt="@@noEvents" alt="No events available">
  }
</div>